module.exports = "<div class=\"product-listing\">\n    <div class=\"row\">\n        <div class=\"col-md-6\">\n            <div ui-view=\"tableView\"></div>\n        </div>\n        <div class=\"col-md-6\">\n            <div ui-view=\"detailsView\"></div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/product/templates/main.html
// module id = 751
// module chunks = 0